export default {
  key: 'system--marketplace',
  routes: [/^\/marketplace(\/|$)/],
  i18nNamespaces: ['marketplace'],
  app:     () => import('./app.js').then(m => m.default),
  context: () => import('./context.js').then(m => m.default),
}
